<template>
  <div class="DarkWhite">
    <v-data-table
      :headers="headers"
      :items="rsmiList"
      :options.sync="options"
      :server-items-length="totalCount"
      :loading="loading"
      :footer-props="footerProps"
      class="elevation-1 pt-2"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-text-field
            style="max-width: 300px"
            v-model="searchText"
            append-icon="mdi-magnify"
            placeholder="Search RSMI number"
            color="green darken-2"
            class="mr-2 mt-2"
            dense
            hide-details
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-autocomplete
            v-model="FundCode"
            item-text="Description"
            item-value="FundCode"
            :items="funds"
            hide-details
            class="mr-2 mt-2"
            style="max-width:200px;"
            color="header"
            label="Filter by Funds"
          >
          </v-autocomplete>
          <v-btn
            color="header"
            dark
            v-if="$store.state.user.roleID == 6"
            @click="createRSMI()"
          >
          <v-icon class="mr-1">mdi-folder-plus</v-icon>
            CREATE RSMI
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:[`item.FundCode`]="{ item }">
        {{ item.FundCode }}
      </template>
      <template v-slot:[`item.DateCreated`]="{ item }">
        {{ formatDate(item.DateCreated) }}
      </template>
      <template v-slot:[`item.Status`]="{ item }">
        <v-chip color="amber darken-2" dark small v-if="item.IsCancelled == 1">Cancelled</v-chip>
        <span v-else>
        <v-chip color="green darken-2" dark small v-if="item.VerifiedStatusID == 7">Verified</v-chip>
        <v-chip color="red darken-2" dark small v-else-if="item.VerifiedStatusID == 6">Pending</v-chip>
        <v-chip color="grey darken-1" dark small v-else-if="item.VerifiedStatusID == null">For Verification</v-chip>
        </span>
      </template>
      <template v-slot:[`item.Actions`]="{ item }">
        <span class="text-no-wrap">
          <v-btn
            color="blue darken-2"
            class="mr-2"
            dark
            outlined
            elevation="2"
            x-small
            @click="viewRSMI(item)"
          >
            View
          </v-btn>
          <v-btn
            color="red darken-2"
            dark
            outlined
            elevation="2"
            x-small
            @click="printRSMI(item)"
          >
            Print
          </v-btn>
        </span>
      </template>
    </v-data-table>
    <CreateRSMIModal :rsmiData="rsmiData" />
    <ViewRSMIModal :rsmiData="viewData" />
    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>

<script>
export default {
  components: {
    CreateRSMIModal: () => import("./CreateRSMI.vue"),
    ViewRSMIModal: () => import("./ViewRSMI.vue"),
  },
  props: {
    fiscalYear: null
  },
  data: () => ({
    searchText: "",
    searchTimeout: null,
    footerProps: { "items-per-page-options": [5, 10, 20, 50, 100, 500] },
    totalCount: 0,
    loading: true,
    options: {},
    fadeAwayMessage: {
      show: false,
      type: "success",
      header: "Successfully Saved!",
      message: "",
      top: 10,
    },
    isLoading: false,
    rsmiList: [],
    rsmiData: [],
    dispenseData: [],
    headers: [
      {
          text: 'RSMI CODE',
          align: 'start',
          sortable: false,
          value: 'RSMICODE',
          class: "green darken-2 white--text text-caption font-weight-bold"
        },
        {
          text: 'Fund Code',
          align: 'center',
          sortable: false,
          value: 'FundYear',
          class: "green darken-2 white--text text-caption font-weight-bold"
        },
        {
          text: 'Description',
          align: 'start',
          sortable: false,
          value: 'Description',
          class: "green darken-2 white--text text-caption font-weight-bold"
        },
        {
          text: '# of RIS',
          align: 'center',
          sortable: false,
          value: 'RISCount',
          class: "green darken-2 white--text text-caption font-weight-bold"
        },
        {
          text: 'Date Created',
          align: 'start',
          sortable: false,
          value: 'DateCreated',
          class: "green darken-2 white--text text-caption font-weight-bold"
        },
        // {
        //   text: 'Printed?',
        //   align: 'center',
        //   sortable: false,
        //   value: 'IsPrinted',
        //   class: "green darken-2 white--text text-caption font-weight-bold"
        // },
        {
        text: "Status",
        value: "Status",
        align: "center",
        sortable: false,
        class: "green darken-2 white--text text-caption font-weight-bold"
      },
        { text: 'Actions', value: 'Actions', align: 'center', width: '140', sortable: false, class: "green darken-2 white--text text-caption font-weight-bold" },
      ],
      itemToPrint: [],
      userList: [],
      userID: 0,
      funds: [],
      FundCode: 0,
      viewData: [],
  }),
  watch: {
    searchText: function () {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.initialize();
      }, 600);
    },
    options: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
    fiscalYear: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
    userID: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
    FundCode: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
  },
  mounted() {
    this.eventHub.$on("closeViewRSMI", () => {
      this.initialize();
    });
    this.eventHub.$on("closeCreateRSMI", () => {
      this.initialize();
    });
    this.getUsers();
    this.getFundCodes();
  },
  beforeDestroy() {
    this.eventHub.$off("closeViewRSMI");
    this.eventHub.$off("closeCreateRSMI");
  },
  methods: {
    createRSMI() {
      this.rsmiData = [];
    },
    viewRSMI(item) {
      this.viewData = item;
    },
    printRSMI(item) {
      this.link = this.apiUrl + "/rsmi/report/" + item.RSMIID;
      window.open(this.link);
    },
    initialize() {
      this.loading = true;
      if(this.fiscalYear != null){
      let data = new FormData();
      if (this.options.page) {
        data.append("page", this.options.page);
        data.append("itemsPerPage", this.options.itemsPerPage);
      } else {
        data.append("page", 1);
        data.append("itemsPerPage", 10);
      }
      data.append("tab", this.tab);
      data.append("searchText", this.searchText);
      data.append("FiscalYearID", this.fiscalYear);
      data.append("UserID", this.userID);
      data.append("FundCode", this.FundCode);
      this.axiosCall("/getRSMIList", "POST", data).then((res) => {
        this.loading = false;
        this.rsmiList = res.data.data.result;
        this.totalCount = res.data.data.total;
        if (this.totalCount <= 10) {
          this.options.page = 1;
        }
      });
      }
    },
    getUsers() {
      this.axiosCall("/getAllPersonsAccountable", "GET").then((res) => {
        this.userList = [{UserID: 0, name: "All"},...res.data.data];
      });
    },
    selectPrinted(item) {
      let data = new FormData();
      data.append("id", item.RSMIID);
      data.append("table", 'rsmi');
      data.append("column", 'RSMIID');
      data.append("IsPrinted", item.IsPrinted ? 1 : 0);
      this.axiosCall("/setPrinted", "POST", data).then((res) => {
        if(res.data.status){
          let msg = item.IsPrinted ? 'printed.' : 'not printed.';
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "success";
          this.fadeAwayMessage.message = item.RSMICODE + " was successfully set to " + msg;
          this.fadeAwayMessage.header = "System Message";
        }
        else{
          item.IsPrinted = !item.IsPrinted;
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "error";
          this.fadeAwayMessage.message = "Something went wrong!";
          this.fadeAwayMessage.header = "System Message";
        }
      });
    },
    getFundCodes() {
      this.axiosCall(
              '/get/getUniqueFundCodes',
              'GET'
          )
          .then((res) => {
              this.funds = this.prepend({FundCode: 0, Description: 'All'},res.data.data);
          })
		},
    prepend(value, array) {
    var newArray = array.slice();
    newArray.unshift(value);
    return newArray;
    },
  },
};
</script>